import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Vision from "./sections/Vision";
import Showcase from "./sections/Showcase";
import Philosophy from "./sections/Philosophy";
import Impact from "./sections/Impact";
import Services from "./sections/Services";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Vision />
      <Showcase />
      <Philosophy />
      <Impact />
      <Services />
      <Testimonials />
      <Footer />
    </div>;
}